export default "/static/dashboard/build/app/img/v2/390384691cdc8f0e2cbb31b73ed1ce1c.png";